export const migrateToV2 = (state)=>{
    return state.map((entity)=>{
        if (entity.type === 'Scene') {
            return {
                ...entity,
                includeCountertop: true
            };
        }
        return entity;
    });
};

//# sourceMappingURL=v2.js.map